<template>
  <div class="stats-tables-wrapper" v-on:scroll="scrollFunction($event)">
    <div class="stats-content">
      <HrStatsTable 
        v-show="currentMetric === sessionMetrics.TIME_ABOVE_80_PERCENT_HR"
        :data="data.TIME_ABOVE_80_PERCENT_HR"
        :stats-segment="statsSegment.TIME_ABOVE_80_PERCENT_HR"
        :activityInfo="activityInfo" 
        :change-avg-hr-unit="changeAvgHrUnit"
        :change-top-hr-unit="changeTopHrUnit"
        :avg-hr-selected-unit="avgHrSelectedUnit"
        :top-hr-selected-unit="topHrSelectedUnit"
        :scroll-left-over25="scrollLeftOver25" />

      <ActiveParticipationStatsTable 
        v-show="currentMetric === sessionMetrics.AP"
        :data="data.AP"
        :stats-segment="statsSegment.AP"
        :activityInfo="activityInfo"
        :change-ap-zones-unit="changeApZonesUnit"
        :ap-zones-selected-unit="apZonesSelectedUnit"
        :scroll-left-over25="scrollLeftOver25" />

      <DistanceSpeedTable 
        key="distance"
        v-show="currentMetric === sessionMetrics.DISTANCE"
        :data="data.DISTANCE"
        :stats-segment="statsSegment.DISTANCE"
        :activityInfo="activityInfo" 
        :change-distance-zones-unit="changeDistanceZonesUnit" 
        :distance-zones-selected-unit="distanceZonesSelectedUnit"
        :scroll-left-over25="scrollLeftOver25"
        :account="account"
         />

      <WorkloadStatsTable 
        key="speed"
        v-show="currentMetric === sessionMetrics.WORKLOAD"
        :data="data.WORKLOAD"
        :stats-segment="statsSegment.WORKLOAD"
        :activityInfo="activityInfo" 
        :change-workload-zones-unit="changeWorkloadZonesUnit" 
        :workload-zones-selected-unit="workloadZonesSelectedUnit"
        :current-metric="currentMetric"
        :scroll-left-over25="scrollLeftOver25" />
    </div>
  </div>
</template>

<script>
import HrStatsTable from '@/components/calendar-activity/HrStatsTable'
import ActiveParticipationStatsTable from '@/components/calendar-activity/ActiveParticipationStatsTable'
import DistanceSpeedTable from '@/components/calendar-activity/DistanceSpeedStatsTable'
import WorkloadStatsTable from '@/components/calendar-activity/WorkloadStatsTable'
import { SESSION_METRICS } from '@/constants/SessionConsts'

export default {
  name: 'PlayerStatsTables',
  props: [
    'data',
    'activityInfo',
    'currentMetric',
    'changeAvgHrUnit',
    'changeTopHrUnit',
    'changeApZonesUnit',
    'changeWorkloadZonesUnit',
    'changeDistanceZonesUnit',
    'avgHrSelectedUnit',
    'topHrSelectedUnit',
    'apZonesSelectedUnit',
    'workloadZonesSelectedUnit',
    'distanceZonesSelectedUnit',
    'statsSegment',
    'account'
  ],
  data () {
    return {
      sessionMetrics: SESSION_METRICS,
      scrollLeftOver25: false
    }
  },
  components: {
    HrStatsTable,
    ActiveParticipationStatsTable,
    DistanceSpeedTable,
    WorkloadStatsTable
  },
  methods : {
    scrollFunction(event) {
      event.target.scrollLeft > 25 ? this.scrollLeftOver25 = true : this.scrollLeftOver25 = false;      
    }
  }
}
</script>

<style lang="scss" scoped>
  .stats-tables-wrapper {
    overflow: auto;

    .fixed-column {
      position: absolute
    }

    .stats-content {
      min-width: 900px;

      .purple-column {
        color: $cerulean-blue !important;
      }
    }
  }
</style>
